var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "layout" }, [
    _c(
      "div",
      { staticClass: "layout_nav" },
      [_c("Nav", _vm._b({}, "Nav", _vm.getRol, false))],
      1
    ),
    _c(
      "div",
      { staticClass: "layout_center" },
      [
        _c(
          "v-container",
          { attrs: { fluid: "" } },
          [
            _c(
              "v-row",
              [
                _c(
                  "v-col",
                  { staticClass: "pa-0" },
                  [_c("Welcome", _vm._b({}, "Welcome", _vm.getUser, false))],
                  1
                ),
                _c(
                  "v-col",
                  { staticClass: "pa-0", attrs: { md: "auto" } },
                  [
                    _vm.getTimerConfig[0] != undefined
                      ? _c(
                          "div",
                          { staticClass: "card_time my-5" },
                          [
                            _c("UpdateTimer", {
                              attrs: {
                                data: _vm.itemObjct,
                                visible: _vm.newTimeFlag,
                              },
                              on: {
                                close: function ($event) {
                                  _vm.newTimeFlag = false
                                },
                              },
                            }),
                            _c("div", { staticClass: "card_title" }, [
                              _c(
                                "p",
                                [
                                  _c(
                                    "v-icon",
                                    {
                                      staticClass: "mr-2",
                                      attrs: { small: "" },
                                    },
                                    [_vm._v("mdi-download-network")]
                                  ),
                                  _vm._v(" Comunicación API "),
                                ],
                                1
                              ),
                            ]),
                            _c("div", { staticClass: "card_copy" }, [
                              _c("p", [
                                _vm._v(
                                  "Cada, " +
                                    _vm._s(_vm.getTimerConfig[0].time) +
                                    " "
                                ),
                                _c("span", [_vm._v("min")]),
                              ]),
                            ]),
                            _vm.isMaster == 1
                              ? _c(
                                  "div",
                                  { staticClass: "card_btn" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        attrs: {
                                          small: "",
                                          color: "secondary",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.editItem(
                                              _vm.getTimerConfig[0]
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v(" Actualizar Tiempo ")]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        )
                      : _vm._e(),
                    _c("Snackbar", {
                      attrs: {
                        visible: _vm.getAlert.snackbar,
                        text: _vm.getAlert.text,
                      },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "v-tabs",
          {
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          },
          [
            _vm.isZone == 1
              ? _c("v-tab", { key: "zone" }, [_vm._v("Zona")])
              : _vm._e(),
            _vm.isCycle == 1
              ? _c("v-tab", { key: "cycle" }, [_vm._v("Ciclo")])
              : _vm._e(),
            _vm.isRoad == 1
              ? _c("v-tab", { key: "road" }, [_vm._v("Ruta")])
              : _vm._e(),
            _vm.isGroupSocial == 1
              ? _c("v-tab", { key: "socialgroup" }, [_vm._v("Estrato")])
              : _vm._e(),
            _vm.isPeriod == 1
              ? _c("v-tab", { key: "period" }, [_vm._v("Periodo")])
              : _vm._e(),
          ],
          1
        ),
        _c(
          "v-tabs-items",
          {
            model: {
              value: _vm.tab,
              callback: function ($$v) {
                _vm.tab = $$v
              },
              expression: "tab",
            },
          },
          [
            _vm.isZone == 1
              ? _c("v-tab-item", { key: "zone" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c("v-col", { staticClass: "pa-0" }, [
                                _c(
                                  "div",
                                  { staticClass: "ctn_btn_new btn_left" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "btn_new",
                                        attrs: { color: "primary" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            _vm.newZoneFlag = true
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-plus-circle-outline"),
                                        ]),
                                        _c("span", [_vm._v(" Crear Zona ")]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0 py-3",
                                  attrs: { sm: "auto" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ctn_indicator" },
                                    [
                                      _c("Indicator", {
                                        attrs: {
                                          active: _vm.getListZone.active,
                                          inactive: _vm.getListZone.inactive,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("TableZone"),
                      _c("NewZone", {
                        attrs: { visible: _vm.newZoneFlag },
                        on: {
                          close: function ($event) {
                            _vm.newZoneFlag = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.isCycle == 1
              ? _c("v-tab-item", { key: "cycle" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c("v-col", { staticClass: "pa-0" }, [
                                _c(
                                  "div",
                                  { staticClass: "ctn_btn_new btn_left" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "btn_new",
                                        attrs: { color: "primary" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            _vm.newCycleFlag = true
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-plus-circle-outline"),
                                        ]),
                                        _c("span", [_vm._v(" Crear Ciclo ")]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0 py-3",
                                  attrs: { sm: "auto" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ctn_indicator" },
                                    [
                                      _c("Indicator", {
                                        attrs: {
                                          active: _vm.getListCycle.active,
                                          inactive: _vm.getListCycle.inactive,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("TableCycle"),
                      _c("NewCycle", {
                        attrs: { visible: _vm.newCycleFlag },
                        on: {
                          close: function ($event) {
                            _vm.newCycleFlag = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.isRoad == 1
              ? _c("v-tab-item", { key: "Road" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c("v-col", { staticClass: "pa-0" }, [
                                _c(
                                  "div",
                                  { staticClass: "ctn_btn_new btn_left" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "btn_new",
                                        attrs: { color: "primary" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            _vm.newRoadFlag = true
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-plus-circle-outline"),
                                        ]),
                                        _c("span", [_vm._v(" Crear Ruta ")]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0 py-3",
                                  attrs: { sm: "auto" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ctn_indicator" },
                                    [
                                      _c("Indicator", {
                                        attrs: {
                                          active: _vm.getListRoad.active,
                                          inactive: _vm.getListRoad.inactive,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("TableComp"),
                      _c("NewRoad", {
                        attrs: { visible: _vm.newRoadFlag },
                        on: {
                          close: function ($event) {
                            _vm.newRoadFlag = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.isGroupSocial == 1
              ? _c("v-tab-item", { key: "socialgroup" }, [
                  _c(
                    "div",
                    [
                      _c(
                        "v-container",
                        { attrs: { fluid: "" } },
                        [
                          _c(
                            "v-row",
                            [
                              _c("v-col", { staticClass: "pa-0" }, [
                                _c(
                                  "div",
                                  { staticClass: "ctn_btn_new btn_left" },
                                  [
                                    _c(
                                      "v-btn",
                                      {
                                        staticClass: "btn_new",
                                        attrs: { color: "primary" },
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            _vm.newSocialFlag = true
                                          },
                                        },
                                      },
                                      [
                                        _c("v-icon", [
                                          _vm._v("mdi-plus-circle-outline"),
                                        ]),
                                        _c("span", [_vm._v(" Crear Estrato ")]),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0 py-3",
                                  attrs: { sm: "auto" },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "ctn_indicator" },
                                    [
                                      _c("Indicator", {
                                        attrs: {
                                          active: _vm.getListSocialGroup.active,
                                          inactive:
                                            _vm.getListSocialGroup.inactive,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("TableSocial"),
                      _c("NewSocial", {
                        attrs: { visible: _vm.newSocialFlag },
                        on: {
                          close: function ($event) {
                            _vm.newSocialFlag = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm.isPeriod == 1
              ? _c("v-tab-item", { key: "period" }, [
                  _c(
                    "div",
                    [
                      _c("div", { staticClass: "layout_row" }, [
                        _c("div", { staticClass: "layout_colum" }, [
                          _c(
                            "div",
                            { staticClass: "ctn_btn_new btn_left" },
                            [
                              _c(
                                "v-btn",
                                {
                                  staticClass: "btn_new",
                                  attrs: { color: "primary" },
                                  on: {
                                    click: function ($event) {
                                      $event.stopPropagation()
                                      _vm.newPeriodFlag = true
                                    },
                                  },
                                },
                                [
                                  _c("v-icon", [
                                    _vm._v("mdi-plus-circle-outline"),
                                  ]),
                                  _c("span", [_vm._v(" Crear Periodo ")]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ]),
                        _c("div", { staticClass: "layout_colum" }, [
                          _c("div", { staticClass: "ctn_indicator" }),
                        ]),
                      ]),
                      _c("TablePeriod"),
                      _c("NewPeriod", {
                        attrs: { visible: _vm.newPeriodFlag },
                        on: {
                          close: function ($event) {
                            _vm.newPeriodFlag = false
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }